import { format, parseISO } from 'date-fns';

const prettifyTime = (date) => format(parseISO(date), 'd MMMM y');

export { prettifyTime };
